import siteLanguage from "../config/siteLanguage";

export default {
    props: {
        mediaTypes: {
            type: Array,
            required: false,
            default: () => {
                return ["Media"];
            },
        },
        mediaType: {
            type: String,
            required: false,
        },
    },
    computed: {
        uploadRoute() {
            const mediaType =
                this.selectedMediaType || this.mediaType || this.mediaTypes[0];
            if (mediaType === "Icon") {
                return route("api.icons.store", siteLanguage.iso.ENGLISH);
            } else if (mediaType === "Screenshot") {
                return route(
                    "api.screenshots.store",
                    this.language?.iso || siteLanguage.iso.ENGLISH
                );
            } else if (mediaType === "Logo") {
                return route("api.logos.store", siteLanguage.iso.ENGLISH);
            } else if (mediaType === "PaymentLogo") {
                return route(
                    "api.paymentLogos.store",
                    siteLanguage.iso.ENGLISH
                );
            } else if (mediaType === "OperatorLogo") {
                return route(
                    "api.operatorLogos.store",
                    siteLanguage.iso.ENGLISH
                );
            } else if (mediaType === "SoftwareLogo") {
                return route(
                    "api.softwareLogos.store",
                    siteLanguage.iso.ENGLISH
                );
            } else if (mediaType === "LicenseLogo") {
                return route(
                    "api.licenseLogos.store",
                    siteLanguage.iso.ENGLISH
                );
            }

            return route(
                "api.media.store",
                this.language?.iso || siteLanguage.iso.ENGLISH
            );
        },
        indexRoute() {
            const mediaType = this.selectedMediaType || this.mediaTypes[0];
            if (mediaType === "Icon") {
                return route("api.icons.index");
            } else if (mediaType === "Screenshot") {
                return route(
                    "api.screenshots.index",
                    this.language?.iso || siteLanguage.iso.ENGLISH
                );
            } else if (mediaType === "Logo") {
                return route("api.logos.index");
            } else if (mediaType === "PaymentLogo") {
                return route("api.paymentLogos.index");
            } else if (mediaType === "OperatorLogo") {
                return route("api.operatorLogos.index");
            } else if (mediaType === "SoftwareLogo") {
                return route("api.softwareLogos.index");
            } else if (mediaType === "LicenseLogo") {
                return route("api.licenseLogos.index");
            }

            return route(
                "api.media.index",
                this.language?.iso || siteLanguage.iso.ENGLISH
            );
        },
    },
};
